import { render, staticRenderFns } from "./HealthScoreDashboard.vue?vue&type=template&id=71dc7bb6&scoped=true&"
import script from "./HealthScoreDashboard.vue?vue&type=script&lang=js&"
export * from "./HealthScoreDashboard.vue?vue&type=script&lang=js&"
import style0 from "./HealthScoreDashboard.vue?vue&type=style&index=0&id=71dc7bb6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71dc7bb6",
  null
  
)

export default component.exports